import { EmbeddedDocumentPostMessageResult } from "./index";

export class EmbeddedDocumentRegistrationPostMessageResult extends EmbeddedDocumentPostMessageResult {
  constructor(
    windowName: string,
    request: string,
    isOk: boolean,
    public detail?: EmbeddedDocumentDetail,
  ) {
    super(windowName, request, isOk);
  }
}

export interface EmbeddedDocumentDetail {
  isTemporary: boolean;
  documentId?: number;
  archiveId?: number;
}
